module.exports = __webpack_public_path__ + "img/head.cb692366.png";